import React, { FunctionComponent, useEffect, useState } from 'react';
import { Pagination } from '@vwfs-bronson/bronson-react';

export interface PaginationModel {
  currentPage: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export interface PaginationProps {
  pagination: PaginationModel;
  onChange?: any;
}

// Pages can be numbers 1 2 3
// There can be also dots. 1 2 3 ... 7 8 9 ... 40 41
// There are two types of dots needed for the 'key' prop to differetiate during iteration

type Page = number | 'first-dots' | 'second-dots';

export const PaginationComponent: FunctionComponent<PaginationProps> = ({ pagination, onChange }) => {
  const { currentPage, totalCount, totalPages } = pagination;

  const [pages, setPages] = useState<Page[]>([]);

  useEffect(() => {
    const startPage = Math.max(3, currentPage - 1);
    const endPage = Math.min(totalPages - 2, currentPage + 1);

    if (totalPages <= 3) {
      setPages(Array.from({ length: totalPages }, (_, i) => i + 1));
      return;
    }

    setPages([1, 2]);
    if (startPage > 3) {
      setPages((pages) => [...pages, 'first-dots']);
    }
    for (let i = startPage; i <= endPage; i++) {
      setPages((pages) => [...pages, i]);
    }
    if (endPage < totalPages - 2) {
      setPages((pages) => [...pages, 'second-dots']);
    }
    if (totalPages > 2) {
      setPages((pages) => [...pages, totalPages - 1, totalPages]);
    }
  }, [currentPage, totalPages]);

  const onItemClick = (e: any, item: Page) => {
    e.preventDefault();
    if (onChange) {
      onChange(item);
    }
  };

  if (!totalCount) return <></>;

  return (
    <Pagination
      prevDisabled={currentPage === 1}
      nextDisabled={totalPages === currentPage}
      onPrevClick={(e) => onItemClick(e, currentPage - 1)}
      onNextClick={(e) => onItemClick(e, currentPage + 1)}
    >
      {pages.map((item: Page) => (
        <Pagination.Item
          key={item}
          active={item === currentPage}
          disabled={typeof item !== 'number'}
          onClick={(e) => onItemClick(e, item)}
        >
          {typeof item === 'number' ? item : '...'}
        </Pagination.Item>
      ))}
    </Pagination>
  );
};
